module.exports = __webpack_public_path__ + "media/co.da6fea84.mp4";